import { SolutionDeletionSettingCard } from "@/components/admin/SolutionDeletionSettingCard";

export function SettingsSystemPage() {
  return (
    <div className="space-y-4">
      <header className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h2 className="font-display text-lg font-semibold">System</h2>
        </div>
      </header>

      <SolutionDeletionSettingCard />
    </div>
  );
}
